import React, { useEffect, useState } from 'react';

const HandleResponsive = () => {
    const [isPopupVisible, setIsPopupVisible] = useState(false);

    useEffect(() => {
        const isMobileDevice = () => {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        };

        if (isMobileDevice()) {
            setIsPopupVisible(true);
        }
    }, []);

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    return (
     <div className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50 ${isPopupVisible ? 'block' : 'hidden'}`}>
        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Responsive Website Under Development</h2>
            <p className="text-gray-600 mb-6">This website is still under development For Responsive Ios dan Android. Thank you for your patience.</p>
            <button
                className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
                onClick={closePopup}
            >
                Close
            </button>
        </div>
    </div>
 );
};

export default HandleResponsive;
